import { NgModule } from '@angular/core';
import { FiDisableLinksDirective } from './disable-links.directive';

@NgModule({
    declarations: [FiDisableLinksDirective],
    exports: [FiDisableLinksDirective],
})
export class FiDisableLinksModule {}
